import React from 'react';
import Seat from '../../../components/Seat';
import WagonStairs from '../../../components/WagonStairs';

function SecondFloor({
  seats,
  setChosenSeats,
  chosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>II</h2>
        </div>

        <div
          className="seats-row left"
          style={{ width: '755.3px', marginLeft: '120px' }}
        >
          <WagonStairs />

          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column" style={{ marginRight: '17px' }}>
            <Seat
              seat={seats?.[92]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[93]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[94]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          {
            [
              [91, 90, 89],
              [88, 87, 86],
              [85, 84, 83],
              [82, 81, 80],
            ].map((seatsRow) => (
              <div className="seat-column reversed" key={seatsRow[0]}>
                <Seat
                  seat={seats?.[seatsRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
            ))
          }
          {
            [
              [77, 78, 79],
              [74, 75, 76],
              [71, 72, 73],
              [68, 69, 70],
            ].map((seatsRow) => (
              <div className="seat-column" key={seatsRow[0]}>
                <Seat
                  seat={seats?.[seatsRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>

            ))
          }
          <div className="seat-column reversed" style={{ marginLeft: '17px' }}>
            <Seat
              seat={seats?.[67]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[66]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[65]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <WagonStairs />
        </div>
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '120px' }}
        >
          <WagonStairs />

          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          {
            [
              [64, 63],
              [62, 61],
            ].map((seatsRow) => (
              <div className="seat-column" key={seatsRow[0]}>
                <Seat
                  seat={seats?.[seatsRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
            ))
          }
          {
            [
              [59, 60],
              [57, 58],
              [55, 56],
            ].map((seatsRow, index) => (
              <div
                className="seat-column reversed"
                style={{ marginLeft: index === 0 ? '17px' : '0' }}
                key={seatsRow[0]}
              >
                <Seat
                  seat={seats?.[seatsRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
            ))
          }
          <div className="seat-column">
            <Seat
              seat={seats?.[54]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[53]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          {
            [
              [51, 52],
              [49, 50],
            ].map((seatsRow, index) => (
              <div
                className="seat-column reversed"
                style={{ marginLeft: index === 0 ? '17px' : '0' }}
                key={seatsRow[0]}
              >
                <Seat
                  seat={seats?.[seatsRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[seatsRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
            ))
          }

          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>

          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <WagonStairs />
        </div>
      </div>
    </div>
  );
}

export default SecondFloor;
